import React, { useState, useEffect } from 'react';

interface LogoProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  showText?: boolean;
  animated?: boolean;
  className?: string;
}

const LogoComponent: React.FC<LogoProps> = ({
  size = 'sm',
  showText = true,
  animated = false,
  className = ''
}) => {
  const [imageError, setImageError] = useState(false);
  
  // Check if we're in production vs development
  const isProduction = import.meta.env.PROD;
  const baseUrl = isProduction ? '' : '';
  const logoSrc = `${baseUrl}/images/CarryNGo.png`;

  // Size mappings for logo image - FIXED: Proper sizes for different contexts
  const imageSizeClasses = {
    xs: 'h-10 w-auto',      // 20px - extra small
    sm: 'h-10 w-auto',      // 28px - small (good for header)
    md: 'h-10 w-auto',      // 36px - medium
    lg: 'h-14 w-auto',     // 44px - large
    xl: 'h-14 w-auto',     // 56px - extra large
    '2xl': 'h-16 w-auto',  // 64px - 2x large
  };

  // Text size mappings - FIXED: Proper text sizes
  const textSizes = {
    xs: 'text-xs',         // 12px
    sm: 'text-md',         // 14px - small text for header
    md: 'text-base',       // 16px
    lg: 'text-lg',         // 18px
    xl: 'text-xl',         // 20px
    '2xl': 'text-2xl',     // 24px
  };

  // Fallback SVG logo
  const fallbackLogo = (
    <svg
      width={size === 'xs' ? 20 : size === 'sm' ? 28 : size === 'md' ? 36 : size === 'lg' ? 44 : size === 'xl' ? 56 : 64}
      height={size === 'xs' ? 20 : size === 'sm' ? 28 : size === 'md' ? 36 : size === 'lg' ? 44 : size === 'xl' ? 56 : 64}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="inline-block"
    >
      <circle cx="50" cy="50" r="45" fill="#10b981" />
      <path
        d="M30 50 L45 65 L70 35"
        stroke="white"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="35" cy="65" r="8" fill="white" />
      <circle cx="65" cy="65" r="8" fill="white" />
    </svg>
  );

  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <div className="flex items-center justify-center">
        {imageError ? (
          fallbackLogo
        ) : (
          <img
            src={logoSrc}
            alt="CarryNGo"
            className={`${imageSizeClasses[size]} object-contain ${animated ? 'animate-pulse' : ''}`}
            onError={() => setImageError(true)}
          />
        )}
      </div>
      {showText && (
        <span className={`font-bold bg-gradient-to-r from-emerald-600 to-green-600 bg-clip-text text-transparent ${textSizes[size]}`}>
          CarryNGo
        </span>
      )}
    </div>
  );
};

export default LogoComponent;